const padZero = (num) => num < 10 ? `0${num}` : num;

export default padZero;